import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import { Modal, Grid, Header, Form } from "semantic-ui-react";


import Select from "react-select";

import { SG_EDIT_FILE_UPLOAD, SG_VALIDATE_EMAIL_LIST } from "constants/actions";

const Update = ({
    rowInfo,
    setRowInfo,
    rowId,
    id,
    ShowPortal,
    openPortal,
    jsonData,
    setJsonData,
    fieldValues,
    validFieldNames,
    fileHeaders,
    categoryLabel,
}) => {
    const dispatch = useDispatch();

    // const [selectionList, setSelectionList] = useState([])

    const [isLoading, setIsLoading] = useState(false)
    function UpdateRow() {
        dispatch({
            type: SG_EDIT_FILE_UPLOAD,
            payload: {
                id: id,
                row_info: rowInfo,
                row_id: rowId,
            },
        });


        ShowPortal(false);
    }


    function ChangeRow(key, value) {
        setIsLoading(key)
        const _rowData = rowInfo;
        _rowData[key] = value;
        // console.log(e.target.value)
        // console.log(key)
        // console.log(value)

        if (key === 'email') {
            dispatch({
                type: SG_VALIDATE_EMAIL_LIST,
                payload: `email=${value}`
            });
        }

        const _full_data = jsonData;
        _full_data[rowId] = _rowData;
        setRowInfo(_rowData);

        // console.log(_rowData)
        // console.log(_full_data)
        dispatch({
            type: SG_EDIT_FILE_UPLOAD,
            payload: {
                id: id,
                row_info: rowInfo,
                row_id: rowId,
            },
        });

        setJsonData(_full_data);
    }

    function ChangeSelectedValue(key, e) {
        ChangeRow(key, e.name);
        // console.log("changed", key)
        // if (controlledBy[key])
        // {
        //     // console.log("Controlled Key Found", e.name, controlledBy[key])
        //     // console.log(rowInfo[controlledBy[key]])
        //     ChangeRow(controlledBy[key], null);
        // }
        console.log(key, e.name)
        // console.log(rowInfo[key])
    }

    useEffect(() => {
        if (!isLoading === false) {
            const timer1 = setTimeout(() => {
                setIsLoading(false);
            }, 1000);
            return () => clearTimeout(timer1);
        }

    }, [rowInfo, dispatch, isLoading]);

    // variable
    function SelectedLists({ variable, optionList, value }) {
        if (optionList) {
            let SelectionListValues = []

            const SetValue = optionList.filter(op => op.name === value)[0]
            SelectionListValues = optionList

            return <Select
                placeholder={`Select ${variable}`}
                onChange={(e) => ChangeSelectedValue(variable, e)}
                value={SetValue}
                options={SelectionListValues}
                isLoading={isLoading === variable ? isLoading : false}
                getOptionLabel={(SelectionListValues) => SelectionListValues?.name}
                getOptionValue={(SelectionListValues) => SelectionListValues?.name}
            />
        }
    }

    // console.log(categoryLabel)

    return (
        <ModernModalOverlay>
            <ModernModal>
                <ModalHeader>
                    <ModalTitle>Update Row</ModalTitle>
                    <CloseButton onClick={() => ShowPortal(false)}>×</CloseButton>
                </ModalHeader>
                
                <ModalContent>
                    <FormContainer>
                        {fileHeaders && fileHeaders.filter(fh => fh !== 'id' &&
                        fh !== 'valid').map((item, i) => {
                            const RowValue = rowInfo[item]

                            if (categoryLabel.includes(item)) {
                                return (
                                    <FormField key={i}>
                                        <FieldLabel>Category {item}</FieldLabel>
                                        <SelectedLists
                                            variable={item}
                                            optionList={validFieldNames?.[item]?.options}
                                            value={RowValue} />
                                    </FormField>
                                )
                            }
                            return (
                                <FormField key={i}>
                                    <FieldLabel>{item}</FieldLabel>
                                    <ModernInput
                                        name={item}
                                        onChange={(e) =>
                                            ChangeRow(
                                                item,
                                                e.target.value
                                            )
                                        }
                                        defaultValue={RowValue}
                                        placeholder={`Enter ${item}`}
                                    />
                                </FormField>
                            )
                        })}
                    </FormContainer>
                </ModalContent>

                <ModalFooter>
                    <ActionButton
                        variant="secondary"
                        onClick={() => ShowPortal(false)}
                    >
                        Cancel
                    </ActionButton>
                    <ActionButton
                        variant="primary"
                        onClick={UpdateRow}
                    >
                        <ButtonIcon>✓</ButtonIcon>
                        Update
                    </ActionButton>
                </ModalFooter>
            </ModernModal>
        </ModernModalOverlay>
    );
};

export default Update;

// Modal Components
const ModernModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(4px);
    animation: fadeIn 0.2s ease-out;

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

const ModernModal = styled.div`
    background: white;
    border-radius: 12px;
    max-width: 500px;
    width: 90%;
    max-height: 80vh;
    overflow: hidden;
    animation: slideUp 0.3s ease-out;

    @keyframes slideUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

const ModalHeader = styled.div`
    padding: 24px 24px 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e5e7eb;
    margin-bottom: 24px;
`;

const ModalTitle = styled.h2`
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 20px;
    color: #1f2937;
    margin: 0;
`;

const CloseButton = styled.button`
    background: transparent;
    border: none;
    color: #6b7280;
    font-size: 24px;
    cursor: pointer;
    padding: 4px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
        color: #374151;
        background: #f9fafb;
    }
`;

const ModalContent = styled.div`
    padding: 0 24px;
    max-height: 60vh;
    overflow-y: auto;
`;

const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const FormField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const FieldLabel = styled.label`
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    font-size: 14px;
    color: #374151;
    text-transform: capitalize;
`;

const ModernInput = styled.input`
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 10px 12px;
    font-family: "Poppins", sans-serif;
    font-size: 14px;
    color: #1f2937;
    background: white;
    transition: all 0.2s ease;

    &:focus {
        outline: none;
        border-color: #476dfa;
        box-shadow: 0 0 0 3px rgba(71, 109, 250, 0.1);
    }

    &::placeholder {
        color: #9ca3af;
    }
`;

const ModalFooter = styled.div`
    padding: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    border-top: 1px solid #e5e7eb;
    margin-top: 24px;
`;

const ActionButton = styled.button`
    background: transparent;
    color: ${(props) => (props.variant === 'primary' ? '#476dfa' : '#6b7280')};
    border: none;
    border-radius: 6px;
    padding: 10px 16px;
    font-family: "Poppins", sans-serif;
    font-weight: ${(props) => (props.variant === 'primary' ? '600' : '500')};
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 6px;

    &:hover {
        color: ${(props) => (props.variant === 'primary' ? '#3d5ce6' : '#374151')};
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
    }
`;

const ButtonIcon = styled.span`
    font-size: 14px;
    line-height: 1;
`;
